<template>
  <v-container class="text-center pr-0 pl-0" fluid>


    
    <v-row v-if="treinoList">

      <v-col cols="12">
        <v-card class="elevation-10 mb-2" :disabled="dialogLoader">
          <v-card-text>
            <v-select
              :items="daysItems"
              v-model="days"
              item-text="title"
              item-value="value"
              label="Período"
              @change="reloadTreinosWithFeedback"
            ></v-select>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="elevation-10 mb-2" :disabled="dialogLoader">
          <v-card-text class="">
            Aqui constam apenas treinos com feedback (like, dislike ou comentário) no período selecionado. 
          </v-card-text>
        </v-card>
      </v-col>

      <v-col v-for="item in treinoList" :key="item.id" cols="12" md="6" lg="4" xl="3">
        <card-treino :item="item" :showAluno="showAluno" />
      </v-col>
    </v-row>

    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Aguarde...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
    </v-dialog>
    </div>
  </v-container>
</template>

<script>

//import axios from 'axios';
import HOST from '@/ws'
import CardTreino from '../../components/CardTreino.vue';
//import SnackBar from "../snackbar";


export default {

  components : {
    CardTreino,
  },
  props: {
    source: String
  },

  mounted () {

    this.reloadTreinosWithFeedback();
  },

  data: () => ({
    
    dialogLoader : false,
    showAluno : true,

    days : 3,
    daysItems : [
      {title : 'Hoje', value : 1},
      {title : 'Últimos 3 dias', value : 3},
      {title : 'Últimos 7 dias', value : 7},
      {title : 'Últimos 30 dias', value : 30},
      {title : 'Últimos 90 dias', value : 90},
    ],
    treinoList : null,

  }),

  methods : {

    ///load-all-treino-with-feedback

    async reloadTreinosWithFeedback(){

      try {
        this.dialogLoader = true;

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };

        // Fetch data:
        let response = await this.axios.get(HOST.HOST + '/treino/load-all-treino-with-feedback?days=' + this.days, config);
        this.treinoList = response.data;
        //console.log('data: \n' + JSON.stringify(response.data));

      } catch (error) {
        console.error('Error loading insights data:', error);
        this.$store.commit("logout");
        this.$router.push("/");
      } finally {
        this.dialogLoader = false;
      }

    },
  }
};
</script>